import React from 'react';

import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

const FeaturedItemsWrapper = styled.div<{ isVisible: boolean }>`
  max-height: ${props => (props.isVisible ? '1000px' : '0')};
  opacity: ${props => (props.isVisible ? '1' : '0')};
  overflow: hidden;
  transition: max-height ${props => (props.isVisible ? '4s' : '0.8s')} ease-out,
    opacity ${props => (props.isVisible ? '0.8s' : '0.8s')} ease-out;
  font-size: 12px;
  padding: 5px 5px 0px 8px;
`;

const BulletList = styled.ul`
  list-style-type: disc;
  padding-left: 20px;
  margin: 6px 0;
`;

const BulletItem = styled.li`
  margin-bottom: 6px;
`;

const TextWrapper = styled.div`
  font-family: Plain;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  text-transform: none;
  letter-spacing: 0px;
  &::first-letter {
    text-transform: uppercase;
  }
`;
interface FeaturedItemsListProps {
  isVisible: boolean;
}

const FeaturedItemsList: React.FC<FeaturedItemsListProps> = ({ isVisible }) => {
  return (
    <FeaturedItemsWrapper isVisible={isVisible}>
      <TextWrapper>
        <FormattedMessage
          defaultMessage="As a Rewards Member, you'll get 60% OFF your first purchause plus access to more rewards:"
          id="site_pdp.text_header"
        />
      </TextWrapper>
      <BulletList>
        <BulletItem>
          <FormattedMessage
            defaultMessage="{saveUpTo} all full-price styles"
            id="site_pdp.save_up_to"
            values={{
              saveUpTo: (
                <b>
                  <FormattedMessage
                    defaultMessage="Up to 25% OFF"
                    id="site_pdp.save_up_to_percentage"
                  />
                </b>
              ),
            }}
          />
        </BulletItem>
        <BulletItem>
          <FormattedMessage
            defaultMessage="<b>Free shipping</b> on all $59.95+ orders"
            id="site_pdp.free_shipping_on_all"
          />
        </BulletItem>
        <BulletItem>
          <FormattedMessage
            defaultMessage="{fitGuarantee} on returns & exchanges"
            id="site_pdp.returns_and_exchanges"
            values={{
              fitGuarantee: (
                <b>
                  <FormattedMessage
                    defaultMessage="90-Day Fit Guarantee"
                    id="site_pdp.fit_guarantee"
                  />
                </b>
              ),
            }}
          />
        </BulletItem>
      </BulletList>
    </FeaturedItemsWrapper>
  );
};

export default FeaturedItemsList;
